import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const Continue = {
  Type: "continue",
  Empty: function () {
    return {
      id: RandomId(6),
      type: Continue.Type
    };
  },

  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node,
      title: "Continue",
      baseWidth: 90,
      bodyHeight: 14,
      tabs: []
    });
  },

  InspectorPanel: class ContinueInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
    }

    render() {
      if (!this.props.selectedQuest) {
        return <></>;
      }

      return (
        <div>
          <div className="panel continue_panel">
            <InspectorNodeHeader title="Continue" />
            Continue nodes tell the router to keep the user on the current quest they are in.
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default Continue;
